import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function CounterSetRow() {
   return (
      <InputRangeRow
         titleProp={"Counter Set"}
         descriptionProp={"m"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={1}
         maxProp={99999}
         propertyNameProp={"counterSet"}
         errorDialogueProp={"1-99,999 only"}
         floatProp={false}
      />
   );
}
